import React from "react";
import { Box, Typography } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styles from "./metricCard.module.scss";

interface MetricCardProps {
  type: "savings" | "pct" | "completion";
  title: string;
  value: string;
  subtitle: string;
  icon?: React.ReactNode;
}

const MetricCard: React.FC<MetricCardProps> = ({
  type,
  title,
  value,
  subtitle,
  icon,
}) => {
  const getCardConfig = () => {
    switch (type) {
      case "savings":
        return {
          background: "linear-gradient(135deg, #5b6b9e 0%, #7b8fc4 100%)",
          icon: icon || <EmojiEventsIcon className={styles.icon} />,
        };
      case "pct":
        return {
          background: "linear-gradient(135deg, #08ADC2 0%, #00e6c3 100%)",
          icon: icon || <AccessTimeIcon className={styles.icon} />,
        };
      case "completion":
        return {
          background: "linear-gradient(135deg, #08ADC2 0%, #00b290 100%)",
          icon: icon || <CheckCircleIcon className={styles.icon} />,
        };
      default:
        return {
          background: "#5b6b9e",
          icon: null,
        };
    }
  };

  const cardConfig = getCardConfig();

  return (
    <Box
      className={styles.container}
      style={{ background: cardConfig.background }}
    >
      <Box className={styles.header}>
        <Box className={styles.iconWrapper}>{cardConfig.icon}</Box>
        <Typography className={styles.title}>{title}</Typography>
      </Box>
      <Typography className={styles.value}>{value}</Typography>
      <Typography className={styles.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

export default MetricCard;
